import { useNavigate } from 'react-router-dom';

import { useFormikForm } from '#/common/hooks';
import { ROUTES } from '#/routes';
import { apiEndpoints, usePostMutation } from '#/services';
import { ChangePasswordValidationSchema, changePasswordInInitialValues } from '#/utils';

export function useChangePassword() {
    const navigate = useNavigate();

    const { mutate: changePassswordApiCall, isPending: changePasswordApiLoading } = usePostMutation({
        url: apiEndpoints.CHANGE_PASSWORD,
        successMessage: 'Password changed successfully!',
        errorMessage: 'Failed to change password!',
    });

    const handleChangePassword = async values => {
        changePassswordApiCall({
            payload: values,
        });
    };

    const navigateToHome = () => {
        navigate(ROUTES.HOME);
    };

    const {
        handleChange: handleChangeReset,
        handleSubmit: handleSubmitReset,
        errors: changePasswordErrors,
        touched: changePasswordTouched,
        values: changePasswordValues,
        setFieldValue: setChangePasswordValues,
    } = useFormikForm(changePasswordInInitialValues, handleChangePassword, ChangePasswordValidationSchema);

    return {
        navigateToHome,
        handleChangeReset,
        handleSubmitReset,
        changePasswordErrors,
        changePasswordTouched,
        changePasswordValues,
        setChangePasswordValues,
        changePasswordApiLoading,
    };
}
